import { useState } from "react";
import { NavbarComponent } from "../shared/navbarComponent"
import axios from "axios";

export const Contact = () => {
    const [formValues, setFormValues] = useState({
        name: '',
        email: '',
        phone: '',
        city: '',
        franchiseType: '',
    });

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setFormValues({
            ...formValues,
            [event.target.name]: value
        });
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const userData = {
            name: formValues.name,
            email: formValues.email,
            phone: formValues.phone,
            city: formValues.city,
            franchiseType: formValues.franchiseType,
        };
        axios.post("https://reqres.in/api/login", userData).then((response) => {
            console.log(response.status, response.data.token);
        });
    };

    const [selectedOption, setSelectedOption] = useState<String>();

    // This function is triggered when the select changes
    const selectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedOption(event.target.value);
    };

    return (<div className="">
        <NavbarComponent />
        {/* ChatGPT */}
        <div className="container my-3">
            <div className="row">
                <div className="col-md-12">
                    <h3 className="mb-4 text-center">VENHA FAZER PARTE DO TIME LIGHTCON!</h3>
                    <p className="justify">
                        Se você tem perfil empreendedor, tem um capital mínimo para investimento, gosta de desafios e, principalmente,
                        gosta de ter bons resultados, você tem grande potencial para se tornar um franqueado Lightcon, em uma das duas
                        opções de franquia:
                    </p>
                    <ul>
                        <li>UNIDADE DE FRANQUIA FABRIL</li>
                        <li>UNIDADE DE FRANQUIA DE REVENDA</li>
                    </ul>
                    <p>Entre em contato e receba todas informações.</p>
                </div>
                <div className="col-md-12">
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label htmlFor="name" className="form-label">Nome:</label>
                            <input type="text" className="form-control" id="name" name="name" value={formValues.name} onChange={handleChange} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">E-mail:</label>
                            <input type="email" className="form-control" id="email" name="email" value={formValues.email} onChange={handleChange} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="phone" className="form-label">Telefone:</label>
                            <input type="tel" className="form-control" id="phone" name="phone" value={formValues.phone} onChange={handleChange} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="city" className="form-label">Cidade:</label>
                            <input type="text" className="form-control" id="city" name="city" value={formValues.city} onChange={handleChange} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="franchiseType" className="form-label">Tipo de franquia:</label>
                            <select className="form-select" id="franchiseType" name="franchiseType" value={formValues.franchiseType} onChange={selectChange}>
                                <option value="">Selecione uma opção</option>
                                <option value="Unidade de franquia fabril">Unidade de franquia fabril</option>
                                <option value="Unidade de franquia de revenda">Unidade de franquia de revenda</option>
                            </select>
                        </div>
                        <button type="submit" className="button">ENVIAR</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
    );
}